import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useCopy } from '../contexts/LanguageContext';
interface ProcessingScreenProps {
  childName: string;
  onDone: () => void;
}
export function ProcessingScreen({
  childName,
  onDone
}: ProcessingScreenProps) {
  const copy = useCopy();
  const messages = [copy.processing.first(childName), copy.processing.second, copy.processing.third];
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const timers = [setTimeout(() => setIndex(1), 950), setTimeout(() => setIndex(2), 1900), setTimeout(onDone, 2800)];
    return () => timers.forEach(clearTimeout);
  }, [onDone]);
  return <section className="mx-auto flex w-full max-w-md flex-1 flex-col items-center justify-center px-8 text-center" role="status" aria-live="polite" data-id="element-95" data-mp="unyqsdekh9yj">
      <div className="relative grid h-28 w-28 place-items-center" data-id="element-96" data-mp="262wzwm4x6hx">
        <motion.span className="absolute h-28 w-28 rounded-full bg-lavender-200/60" animate={{
        scale: [1, 1.18, 1],
        opacity: [0.5, 0.15, 0.5]
      }} transition={{
        duration: 2.2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-97" data-mp="24jiobk1h5is" />
        <motion.div className="h-14 w-14 rounded-full border-[3px] border-lavender-200 border-t-violet-500" animate={{
        rotate: 360
      }} transition={{
        duration: 1.1,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-98" data-mp="3hsd0fz82ay3q" />
      </div>

      <AnimatePresence mode="wait" data-id="element-99" data-mp="38qdjt80ylw1b">
        <motion.p key={index} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} transition={{
        duration: 0.35
      }} className="mt-7 font-display text-lg text-ink" data-id="element-100" data-mp="33tdmpmm383mc">
          {messages[index]}
        </motion.p>
      </AnimatePresence>
    </section>;
}